export const MODEL_REGISTER = {
  address: "",
  bussinessName: "",
  city: "",
  confirm: "",
  email: "",
  firstName: "",
  ird: "",
  lastName: "",
  logo: "",
  password: "",
  phone: "",
  postCode: "",
  state: "",
  subUrb: "",
};
